import { AbstractControl, ValidatorFn } from '@angular/forms';

/**
 * Class providing a custom validator to ensure startTime is before endTime.
 */
export class TimeRangeValidator {
	/**
	 * Returns a ValidatorFn that checks if the startTime is less than the endTime.
	 * @param startTimeControlName - The name of the startTime control.
	 * @param endTimeControlName - The name of the endTime control.
	 * @returns A ValidatorFn that performs the time validation.
	 */
	static validate<T>(startTimeControlName: Extract<keyof T, string>, endTimeControlName: Extract<keyof T, string>): ValidatorFn {
		return (form: AbstractControl) => {
			const startControl = form.get(startTimeControlName);
			const endControl = form.get(endTimeControlName);

			if (!startControl || !endControl) return null;

			const startTime = startControl.value;
			const endTime = endControl.value;

			if (!startTime || !endTime) {
				return null;
			}

			const [startHours, startMinutes] = startTime.split(':').map(Number);
			const [endHours, endMinutes] = endTime.split(':').map(Number);

			const startDate = new Date();
			startDate.setHours(startHours, startMinutes, 0, 0);

			const endDate = new Date();
			endDate.setHours(endHours, endMinutes, 0, 0);

			if (startDate >= endDate) {
				const error = { custom: 'Start time must be before end time.' };
				endControl.setErrors(error);
				startControl.setErrors(error);
				return error;
			} else {
				startControl.setErrors(null);
				endControl.setErrors(null);
				return null;
			}
		};
	}
}
